export default "__VITE_ASSET__DQR2Ydj6__"